import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store, { setupStore } from './store';
import ElementUI from 'element-ui'; // 引入 ElementUI
import 'normalize.css/normalize.css'; // 重置浏览器样式
import './styles/element-variables.scss'; // 引入 ElementUI 样式，该文件内可直接改变 SCSS 变量来更改组件颜色风格等
import './styles/common.scss'; // 引入公用样式
import * as echarts from 'echarts';
import {TitleComponent, ToolboxComponent, TooltipComponent, GridComponent} from 'echarts/components';
import { LineChart } from 'echarts/charts';
import { UniversalTransition } from 'echarts/features';
import { CanvasRenderer } from 'echarts/renderers';

Vue.config.productionTip = false;

echarts.use([  TitleComponent, ToolboxComponent, TooltipComponent, GridComponent, LineChart, CanvasRenderer, UniversalTransition]);
Vue.prototype.$echarts = echarts;
Vue.use(ElementUI, { size: 'medium' }); // 注册 ElementUI

setupStore();

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
